module.exports = __webpack_public_path__ + "static/pinpoint-local_logo-b391523ea22aa15857ca083ffa47d5a8.png";